import { ComponentVersions_3_0, ComponentVersionsInherit, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { ExpoStandCreate, ExpoStandEdit, ExpoStandList } from './ExpoStands'

const ExpoStandTitle = ({ record }) => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography variant="body1">
        {translate('Expo Stands')} - {record && record.title ? `"${record.title}"` : ''}
      </Typography>
    </ComponentVersionsInherit>
  )
}

export default {
  list: ExpoStandList,
  create: ExpoStandCreate,
  edit: ExpoStandEdit,
  options: {
    create: {
      title: <Typography variant="body1">Expo Stands</Typography>,
      subtitle: null,
      breadCrumb: 'Create Expo Stand',
    },
    list: {
      title: <Typography variant="body1">Expo Stands</Typography>,
      subtitle: null,
      breadCrumb: 'Expo Stands',
    },
    edit: {
      title: <ExpoStandTitle />,
      subtitle: null,
      breadCrumb: 'Edit Expo Stand',
    },
  },
}
